import Vue from 'vue'
import App from './App'
import router from './router'
//引入公用样式
import '../src/assets/css/common.css'
//动画文件
import animated from 'animate.css'
import $ from 'jquery'
import plugin from './plugin'
//import axios from './request/api.js'   //引入axios文件夹
import axios from "axios";
Vue.prototype.$axios = axios;   //挂载到整个Vue原型上

Vue.config.productionTip = false;

import iView from 'iview'    //引入ivew库
import 'iview/dist/styles/iview.css'    // 使用 CSS
Vue.use(iView);
Vue.use(animated);
Vue.use(plugin);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js